module.exports = __webpack_public_path__ + "img/success-academy-me.80f5d921.png";